import {Controller} from "stimulus"

export default class extends Controller {
  static targets = ["menu"];
  static classes = ["hide"];

  toggle() {
    if (this.element.open) {
      this.menuTarget.classList.remove(this.hideClass);
    } else {
      this.menuTarget.classList.add(this.hideClass);
    }
  }

  close() {
    this.element.removeAttribute("open");
  }

  dismiss(event) {
    if (!this.element.open) return false;

    if (this.element.contains(event.target) === false) {
      this.element.removeAttribute("open");
    }
  }
}
